import {
  DocumentHistoryActionType,
  GetDocumentHistoryStartAction,
  GetDocumentHistorySuccessAction,
  GetDocumentHistoryFailureAction,
  ResendDocumentStartAction,
  ResendDocumentFailureAction,
  ResendDocumentSuccessAction
} from './document-history.actions';
import { createReducer } from '@common/redux-utils';
// import { CommentViewModel } from '@models/Comment';
import { DocumentHistoryViewModel } from '@models/DocumentHistory';

// Defining the state of the page.
// Should be one per page.
// All properties should be readonly.
export interface DocumentHistoryState {
  readonly entityId: number;
  readonly message?: string;
  readonly documentsLoading?: boolean;
  readonly documents?: DocumentHistoryViewModel[];
  readonly documentHistoryVM: DocumentHistoryViewModel | null;
}

// This is the initial state of the page
const initialState: DocumentHistoryState = {
  entityId: 0,
  message: '',
  documentsLoading: false,
  // documents: null,
  documentHistoryVM: null
};

/********** Search **********/
function handleGetDocumentHistoryStart(
  state: DocumentHistoryState,
  action: GetDocumentHistoryStartAction
): DocumentHistoryState {
  return {
    ...state,
    message: 'Search Init',
    entityId: action.entityId,
    documentsLoading: true
  };
}

function handleGetDocumentHistorySuccess(
  state: DocumentHistoryState,
  action: GetDocumentHistorySuccessAction
): DocumentHistoryState {
  return {
    ...state,
    message: 'Load Success!',
    documentsLoading: false,
    documents: action.result
  };
}

function handleGetDocumentHistoryFailure(
  state: DocumentHistoryState,
  action: GetDocumentHistoryFailureAction
): DocumentHistoryState {
  return {
    ...state,
    message: action.errorMessage,
    documentsLoading: false
  };
}

function handleResendDocumentFailure(
  state: DocumentHistoryState,
  action: ResendDocumentFailureAction
): DocumentHistoryState {
  return state;
}

function handleResendDocumentStart(
  state: DocumentHistoryState,
  action: ResendDocumentStartAction
): DocumentHistoryState {
  return state;
}

function handleResendDocumentSuccess(
  state: DocumentHistoryState,
  action: ResendDocumentSuccessAction
): DocumentHistoryState {
  return state;
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const DocumentHistoryReducer = createReducer(initialState, {
  /********** Search **********/
  [DocumentHistoryActionType.GetDocumentHistoryStart]: handleGetDocumentHistoryStart,
  [DocumentHistoryActionType.GetDocumentHistorySuccess]: handleGetDocumentHistorySuccess,
  [DocumentHistoryActionType.GetDocumentHistoryFailure]: handleGetDocumentHistoryFailure,
  [DocumentHistoryActionType.ResendDocumentStart]: handleResendDocumentStart,
  [DocumentHistoryActionType.ResendDocumentSuccess]: handleResendDocumentSuccess,
  [DocumentHistoryActionType.ResendDocumentFailure]: handleResendDocumentFailure
});



// WEBPACK FOOTER //
// ./src/document-history/document-history.reducer.ts